import { Box, Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import AHMIS, { API_URL } from '../../../../../api/api';
import AddAlertMessage from '../../../../../components/alert/Alert';
import CustomModal from '../../../../../components/modal/CustomModal';
import DeleteRegisterRecordConformation from '../../../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation';
import RegisterHeader from '../../../../../components/register-header/RegisterHeader';
import NepaliCalender from '../../../../../components/nepali-calender';
import SwarnaBinduPradarshanRegisterTable from '../../../../../pages/users/components/register/swarna-bindu-pradarshan-register/SwarnaBinduPradarshanRegisterTable';
import { ERROR, SOMETHING_WENT_WRONG, SUCCESS } from '../../../../../utils/constants';

const SwarnaBinduPradarshanRegister = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalDefaultValues, setModalDefaultValues] = useState({});
  const { register, handleSubmit, setValue, formState: { errors }, reset } = useForm();
  const [totalSize, setTotalSize] = useState();
  const [tableData, setTableData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const { rowsPerPage, pageNumber } = useSelector((state) => state.searchFilter);

  useEffect(() => {
    if (fromDate && toDate) {
      getData(fromDate, toDate, searchParams);
    }
  }, [fromDate, toDate, searchParams, pageNumber, rowsPerPage]);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    reset({
      dartaaMiti: "",
      maleSixToElevenMonths: "",
      femaleSixToElevenMonths: "",
      maleOneToTwoYears: "",
      femaleOneToTwoYears: "",
      maleTwoToFiveYears: "",
      femaleTwoToFiveYears: ""
    });
    setShowModal(false);
    setModalDefaultValues({});
  };

  const submitForm = (data) => {
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
    }
    AHMIS.post(API_URL.swarnaBinduBulkEntry, data)
      .then((response) => {
        if (response.data.type === SUCCESS) {
          closeModal();
          getData(fromDate, toDate);
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(() => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const getData = (fromDate, toDate, searchParam) => {
    let url = `${API_URL.swarnaBinduBulkEntry}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageNumber}&rowSize=${rowsPerPage}`;
    AHMIS.get(url)
      .then((response) => {
        let jsondata = response.data;
        setTableData(jsondata?.data?.objectList || []);
        setTotalSize(jsondata?.data?.size);
      })
      .catch(() => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const editRow = async (id) => {
    try {
      const response = await AHMIS.get(API_URL.swarnaBinduBulkEntry + "/" + id);
      const data = response?.data?.data;
      setModalDefaultValues(data);
      setShowModal(true);
      if (data) {
        Object.keys(data).forEach(key => {
          setValue(key, data[key]);
        });
      }
    } catch {
      AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
    }
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  const onDeleteRow = (id) => {
    setShowDeleteModal(true);
    setDeleteId(id);
  };

  const deleteRow = (data) => {
    AHMIS.delete(API_URL.swarnaBinduBulkEntry + "/" + deleteId + "?deletedReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowDeleteModal(false);
          setDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          getData(fromDate, toDate);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(() => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const handleDateChange = (name, dateInMilli) => {
    setValue(name, dateInMilli);
  };

  return (
    <>
      <Box marginTop={3}>
        <RegisterHeader
          registerTitle="स्वर्णबिन्दु प्राशन रजिष्टर"
          handleModalOpen={openModal}
          getRegisterData={getData}
          lazyLoading
        />
      </Box>
      <CustomModal
        title="स्वर्णबिन्दु प्राशन रजिष्टरमा नयाँ रेकर्ड थप्नुहोस्।"
        showModal={showModal}
        onModalSubmit={handleSubmit(submitForm)}
        onModalClose={closeModal}
        maxWidth="lg"
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <NepaliCalender
              id="pradarshan-darta-miti"
              name="dartaaMiti"
              onChange={handleDateChange}
              label="स्वर्णप्राशन मिति"
              defaultDate={modalDefaultValues?.dartaaMiti}
              showDefaultDate
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="६ महिनादेखि १ वर्षसम्म (बालक)"
              defaultValue={modalDefaultValues?.maleSixToElevenMonths}
              type="number"
              size="small"
              variant="outlined"
              {...register("maleSixToElevenMonths")}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="६ महिनादेखि १ वर्षसम्म (बालिका)"
              defaultValue={modalDefaultValues?.femaleSixToElevenMonths}
              type="number"
              size="small"
              variant="outlined"
              {...register("femaleSixToElevenMonths")}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="१ वर्षदेखि २ वर्षसम्म (बालक)"
              defaultValue={modalDefaultValues?.maleOneToTwoYears}
              type="number"
              size="small"
              variant="outlined"
              {...register("maleOneToTwoYears")}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="१ वर्षदेखि २ वर्षसम्म (बालिका)"
              defaultValue={modalDefaultValues?.femaleOneToTwoYears}
              type="number"
              size="small"
              variant="outlined"
              {...register("femaleOneToTwoYears")}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="२ वर्षदेखि ५ वर्षसम्म (बालक)"
              defaultValue={modalDefaultValues?.maleTwoToFiveYears}
              type="number"
              size="small"
              variant="outlined"
              {...register("maleTwoToFiveYears")}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="२ वर्षदेखि ५ वर्षसम्म (बालिका)"
              defaultValue={modalDefaultValues?.femaleTwoToFiveYears}
              type="number"
              size="small"
              variant="outlined"
              {...register("femaleTwoToFiveYears")}
              fullWidth
            />
          </Grid>
        </Grid>
      </CustomModal>
      <DeleteRegisterRecordConformation
        showDeleteModal={showDeleteModal}
        closeDeleteModel={closeDeleteModal}
        deleteRecord={deleteRow}
      />
      <Box mt={2}>
        <SwarnaBinduPradarshanRegisterTable
          onEditRow={editRow}
          tableData={tableData}
          deleteRow={onDeleteRow}
          totalSize={totalSize}
        />
      </Box>
    </>
  );
};

export default SwarnaBinduPradarshanRegister;
